import { subscribeChannel, publishChannel } from './channelUtils';

export function sendOrder(order) {
    
    publishChannel('order-upsert', order);

}

export function sendOrderASC(orderASC) {
    
    publishChannel('order-asc-upsert', orderASC);

}

export function listenOrder(callback) {

    return subscribeChannel((event) => {

        const { tipo, payload } = event.data;

        if (
            tipo !== 'order-upsert' &&
            tipo !== 'order-asc-upsert'
        ) {
            return;
        }

        callback({ tipo, payload });

    });

}